import { FC, ReactNode } from 'react';

import { Card, CardContent } from '../../atoms';
import { Illustrations, IllustrationVariant } from '../../atoms/Illustrations/Illustrations';

type EmptyStateProps = {
  title: string;
  description: string;
  illustrationVariant: IllustrationVariant;
  bottomAction?: ReactNode;
  omitCard?: boolean;
};

export const EmptyState: FC<EmptyStateProps> = ({
  title,
  description,
  illustrationVariant,
  bottomAction,
  omitCard = false,
}) => {
  const body = (
    <>
      <div className="mb-5">
        <Illustrations variant={illustrationVariant} />
      </div>
      <div>
        <p className="text-body-16-semibold text-custom-warm-grey-800 text-center mb-2">{title}</p>
        <p className="text-body-14-regular text-custom-warm-grey-600 max-w-[400px] mx-auto text-center">
          {description}
        </p>
      </div>
      {bottomAction && <div className="mt-5">{bottomAction}</div>}
    </>
  );

  if (omitCard) {
    return (
      <div
        className="flex flex-col items-center px-4 py-10"
        data-slot="empty-state-embedded"
        data-testid="empty-state-embedded"
      >
        {body}
      </div>
    );
  }

  return (
    <Card
      className="rounded-[12px] border border-custom-warm-grey-200 bg-white px-4 py-10 shadow-none"
      data-slot="empty-state-card"
      data-testid="empty-state-card"
    >
      <CardContent className="flex flex-col items-center">{body}</CardContent>
    </Card>
  );
};
